const styles = (theme) => ({
  phoneIcon: {
    fontSize: '2rem',
  },
  detailText: {
    textAlign: 'left',
  },
  callButton: {
    width: 56,
    height: 56,
    borderRadius: '50%',
    padding: 11,
    backgroundColor: theme.palette.primary.dark,
    color: 'white !important',
  },
  contactInfoContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  contactInfo: {
    display: 'inline-block',
  },
  contactInfoAction: {
    display: 'inline-block',
    verticalAlign: 'top',
    marginRight: theme.spacing.unit * 2,
  },
});

export default styles;
